<br>

<h3>Top 5 Clienti / Anno</h3>
<div style="display: block;">
  <canvas #clienti></canvas>
</div>

<hr>

<h3>Venduto anno</h3>
<div style="display: block;  max-width: 500px; margin: auto;">
  <canvas #venduto></canvas>
</div>
